import { selectSharepointAuthUrl } from "../selectors";
import { SP_AUTH_REDIRECT_KEY } from "./constants";
import { isValidAuthUrl } from "./utils";

export const redirectToSharepointAuth = (target) => (dispatch, getState) => {
  const authUrl = selectSharepointAuthUrl(getState());
  const { chooseFilesModal, collections } = getState();

  if (!isValidAuthUrl(authUrl)) return;

  const hadLocalFiles = (chooseFilesModal?.files || []).length > 0;
  const selectedCollectionId = collections?.selected?.id ?? null;

  localStorage.setItem(
    SP_AUTH_REDIRECT_KEY,
    JSON.stringify({
      source: "CHOOSE_FILES",
      target,
      hadLocalFiles,
      selectedCollectionId,
      timestamp: Date.now(),
    })
  );

  window.location.href = authUrl;
};
